import React from "react";
import MaterialProgress from "components/MaterialProgress/MaterialProgress";

import { PlantItem } from "components/StyledComponents";

import ItemShipmentQuantitySubscriber from "./ItemShipmentQuantitySubscriber";

// Each item's quantity comes from the PLANT_LOCATIONS query (httpClient cache),
// which the subscriber patches on every event. The parent no longer needs an
// onSubscriptionData callback to keep a local copy in sync: it reads the same
// live props these bars do.
const MultipleProgressSubscriptionWrapper = ({
  concreteShipmentId,
  inventoryItems,
}) => (
  <React.Fragment>
    {
      inventoryItems.map(item => (
        <React.Fragment key={item.id}>
          <ItemShipmentQuantitySubscriber
            inventoryItemId={item.id}
            concreteShipmentId={concreteShipmentId}
          />
          <PlantItem>
            <MaterialProgress
              small
              title={item.name}
              value={item.itemShipmentQuantity || 0}
              total={item.shipmentMaterial ? item.shipmentMaterial.formulaWeight : 0}
            />
          </PlantItem>
        </React.Fragment>
      ))
    }
  </React.Fragment>
);

export default MultipleProgressSubscriptionWrapper;
